<template>
  <b-row class="more-info no-gutters">
    <b-col class="tool-border" cols="12">
      <b-col class="reduce-padding" cols="12">
        <wlpHeader :pageTitle="pageTitle"></wlpHeader>
      </b-col>
      <b-col class="page-background-gradient reduce-padding" cols="12">
        <b-row class="page-content-singles no-gutters">
          <b-row class="body-sec no-gutters">
            <b-row class="scroll no-gutters">
              <b-col
                :class="{
                  'max-width-sp': $i18n.locale == 'sp',
                  'max-width': $i18n.locale == 'en',
                }"
                cols="12"
              >
                <b-row class="no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">{{ $t("info.h1") }}</div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text">{{ $t("info.text1") }}</div>
                  </b-col>
                </b-row>
                <b-row class="no-gutters">
                  <b-col class="comb-spacings reduce-padding" cols="12">
                    <b-row class="vertical-spacing no-gutters">
                      <b-col
                        class="stroke-img comb-img reduce-padding"
                        cols="1"
                        sm="1"
                        md="1"
                      ></b-col>
                      <b-col class="text-spacing" cols="11" sm="11" md="11">
                        <div class="comb-heading">
                          {{ $t("info.h2-stroke") }}
                        </div>
                        <div class="paragraph-text">
                          {{ $t("info.text2-stroke") }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="comb-spacings reduce-padding" cols="12">
                    <b-row class="vertical-spacing no-gutters">
                      <b-col
                        class="heart-img comb-img reduce-padding"
                        cols="1"
                        sm="1"
                        md="1"
                      ></b-col>
                      <b-col class="text-spacing" cols="11" sm="11" md="11">
                        <div class="comb-heading">
                          {{ $t("info.h3-heart") }}
                        </div>
                        <div class="paragraph-text">
                          {{ $t("info.text3-heart") }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="comb-spacings reduce-padding" cols="12">
                    <b-row class="vertical-spacing no-gutters">
                      <b-col
                        class="meta-img comb-img reduce-padding"
                        cols="1"
                        sm="1"
                        md="1"
                      ></b-col>
                      <b-col class="text-spacing" cols="11" sm="11" md="11">
                        <div class="comb-heading">
                          {{ $t("info.h4-metabolic") }}
                        </div>
                        <div class="paragraph-text">
                          {{ $t("info.text4-metabolic") }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="comb-spacings reduce-padding" cols="12">
                    <b-row class="vertical-spacing no-gutters">
                      <b-col
                        class="apnea-img comb-img reduce-padding"
                        cols="1"
                        sm="1"
                        md="1"
                      ></b-col>
                      <b-col class="text-spacing" cols="11" sm="11" md="11">
                        <div class="comb-heading">
                          {{ $t("info.h5-sleep") }}
                        </div>
                        <div class="paragraph-text">
                          {{ $t("info.text5-sleep") }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="comb-spacings reduce-padding" cols="12">
                    <b-row class="vertical-spacing no-gutters">
                      <b-col
                        class="other-img comb-img reduce-padding"
                        cols="1"
                        sm="1"
                        md="1"
                      ></b-col>
                      <b-col class="text-spacing" cols="11" sm="11" md="11">
                        <div class="comb-heading">
                          {{ $t("info.h6-others") }}
                        </div>
                        <div class="paragraph-text">
                          {{ $t("info.text6-others") }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="sec-spacing no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h7-COVID-19") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text">
                      {{ $t("info.text7-COVID-19") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="sec-spacing no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h8-goals") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div
                      class="paragraph-text"
                      :class="{ 'padding-10': $i18n.locale == 'sp' }"
                    >
                      {{ $t("info.text8-goals-1") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div
                      :class="{
                        'graph-img-sp': $i18n.locale == 'sp',
                        'graph-img': $i18n.locale == 'en',
                      }"
                    ></div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text align-breaks">
                      {{ $t("info.text8-goals-2") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="rec-heading">
                      {{ $t("info.h9-recommended") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <ul>
                      <li class="padding-45">
                        {{ $t("info.text9-recommended-1") }}
                      </li>
                      <li class="common-list bottom-space">
                        {{ $t("info.text9-recommended-2") }}
                      </li>
                      <li class="common-list bottom-space padding-5">
                        {{ $t("info.text9-recommended-3") }}
                      </li>
                      <li class="common-list bottom-space top-li">
                        {{ $t("info.text9-recommended-4") }}
                      </li>
                      <li
                        class="common-list bottom-space top-li"
                        :class="{
                          'align-breaks': $i18n.locale == 'en',
                          ' align-breaks-sp': $i18n.locale == 'sp',
                        }"
                      >
                        {{ $t("info.text9-recommended-5") }}
                      </li>
                    </ul>
                  </b-col>
                </b-row>
                <b-row class="bullet-sec-spacing no-gutters cancer">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h10-cancer") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text">
                      {{ $t("info.text10-cancer") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <ul>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-1") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-2") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-3") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-4") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-5") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-6") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-7") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-8") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-9") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-10") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-11") }}
                      </li>
                      <li class="common-list cancer-list">
                        {{ $t("info.text10-cancer-12") }}
                      </li>
                    </ul>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text align-breaks-c">
                      {{ $t("info.text10-cancer-13") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="sec-spacing no-gutters dyslipidemia">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h11-dyslipidemia") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text align-breaks2">
                      {{ $t("info.text11-dyslipidemia") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="htn-sec-spacing no-gutters hypertension">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h12-hypertension") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text">
                      {{ $t("info.text12-hypertension") }}
                    </div>
                    <ul>
                      <li
                        class="hyper-list"
                        :class="{ 'padding-45': $i18n.locale == 'sp' }"
                      >
                        {{ $t("info.text12-hypertension-1") }}
                      </li>
                      <li class="hyper-list">
                        {{ $t("info.text12-hypertension-2") }}
                      </li>
                      <li class="hyper-list">
                        {{ $t("info.text12-hypertension-3") }}
                      </li>
                      <li class="hyper-list">
                        {{ $t("info.text12-hypertension-4") }}
                      </li>
                    </ul>
                  </b-col>
                </b-row>
                <b-row
                  v-if="$i18n.locale == 'sp'"
                  class="nafld bullet-sec-spacing no-gutters"
                >
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h13-liver") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text">
                      {{ $t("info.text13-liver") }} {{ "\xa0"
                      }}{{ $t("info.text13-liver2") }} {{ "\xa0"
                      }}{{ $t("info.text13-liver3") }} {{ "\xa0"
                      }}{{ $t("info.text13-liver4") }} {{ "\xa0"
                      }}{{ $t("info.text13-liver5") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="osteoarthritis htn-sec-spacing no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h14-osteoarthritis") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="common-breaks paragraph-text">
                      {{ $t("info.text14-osteoarthritis") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pcos htn-sec-spacing no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h15-pcos") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div
                      class="paragraph-text"
                      :class="{
                        'padding-10': $i18n.locale == 'sp',
                        'align-breaks2': $i18n.locale == 'en',
                      }"
                    >
                      {{ $t("info.text15-pcos") }} {{ "\xa0"
                      }}{{ $t("info.text15-pcos2") }} {{ "\xa0"
                      }}{{ $t("info.text15-pcos3") }} {{ "\xa0"
                      }}{{ $t("info.text15-pcos4") }}
                    </div>
                  </b-col>
                </b-row>

                <b-row class="type2Diabetes htn-sec-spacing no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h16-diabetes") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-text">
                      {{ $t("info.text16-diabetes") }}
                    </div>
                    <div class="common-paragraphs sub-heading">
                      <b>{{ $t("info.h17-weight") }}</b>
                    </div>
                    <div
                      :class="{
                        'common-breaks-sp': $i18n.locale == 'sp',
                        'padding-3': $i18n.locale == 'en',
                      }"
                    >
                      {{ $t("info.text17-weight-1") }}
                    </div>
                    <div class="common-paragraphs">
                      {{ $t("info.text17-weight-2") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="lifeLost sec-spacing no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h18-life") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="extra-width yll-space paragraph-text">
                      {{ $t("info.text18-life") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="htn-sec-spacing no-gutters">
                  <b-col class="reduce-padding" cols="12">
                    <div class="paragraph-heading">
                      {{ $t("info.h19-aha") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div class="common-paragraphs2 sub-heading">
                      <b>{{ $t("info.h20-aha-weight") }}</b>
                    </div>
                    <div class="extra-width paragraph-text">
                      {{ $t("info.text20-aha-weight") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div
                      class="common-paragraphs top-spacing-heading sub-heading"
                    >
                      <b>{{ $t("info.h21-aha-trained") }}</b>
                    </div>
                    <div class="paragraph-text">
                      {{ $t("info.text21-aha-trained") }}
                    </div>
                  </b-col>
                  <b-col class="reduce-padding" cols="12">
                    <div
                      class="common-paragraphs top-spacing-heading sub-heading"
                    >
                      <b>{{ $t("info.h22-aha-lifestyle") }}</b>
                    </div>
                    <div :class="{ 'align-breaks': $i18n.locale == 'sp' }">
                      {{ $t("info.text22-aha-lifestyle-1") }}
                    </div>
                    <div class="intervention-text">
                      {{ $t("info.text22-aha-lifestyle-2") }}
                    </div>
                    <div class="common-paragraphs top-spacing-heading2">
                      <b>{{ $t("info.h23-components") }}</b>
                    </div>
                    <ul class="last-ul">
                      <li class="common-paragraphs">
                        <b>{{ $t("info.h24-diet") }}</b>
                        {{ $t("info.text24-diet") }} {{ "\xa0"
                        }}{{ $t("info.text24-diet2") }}
                      </li>
                      <li class="common-paragraphs align-breaks">
                        <b>{{ $t("info.h25-activity") }}</b>
                        {{ $t("info.text25-activity") }} {{ "\xa0"
                        }}{{ $t("info.text25-activity2") }}
                      </li>
                      <li class="common-breaks common-paragraphs">
                        <b>{{ $t("info.h26-therapy") }}</b>
                        {{ $t("info.text26-therapy") }} {{ "\xa0"
                        }}{{ $t("info.text26-therapy2") }}
                      </li>
                    </ul>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-row>
        </b-row>
        <wlpNavigation
          :navButtons="['references', 'tnc', 'previous', 'menu2']"
          :currentScreen="20"
        ></wlpNavigation>
      </b-col>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import scrollMixin from "../mixins/scrollMixin";
import wlpHeader from "../components/wlpHeader.vue";
import wlpNavigation from "../components/wlpNavigation.vue";

export default {
  name: "moreInfo",
  mixins: [scrollMixin],
  computed: {
    ...mapGetters("userData", ["userData"]),
  },
  mounted: function () {
    this.$nextTick(function () {
      if (
        this.userData.infoAnchor == "undefined" ||
        this.userData.infoAnchor == ""
      ) {
        this.scrollToTop();
      } else {
        document.querySelector("." + this.userData.infoAnchor).scrollIntoView();
        // scroll to error for iphones
        // if ('parentIFrame' in window) {
        //   var elmTop = document.querySelector('.haserror').getBoundingClientRect().top;
        //   if (elmTop > 0) {
        //     parentIFrame.scrollToOffset(0, elmTop - 200);
        //   }
        // }
      }
    });
  },
  components: {
    wlpNavigation: wlpNavigation,
    wlpHeader: wlpHeader,
  },

  data() {
    return {
      pageTitle: this.$t("info.pageTitle"),
    };
  },
};
</script>


<style lang="scss" scoped>
</style>
